import React, { Component } from 'react';
import './loadingScreen.css';

import Happy from '../../assets/happy1.png';

export default class Loading extends Component {
  render() {
    return (
      <div id='loadingScreen'>
        <img alt='happy' src={Happy} />
        <p className='blink'>Calculating happiness...</p>
      </div>
    )
  }
}
